import { createFileRoute, redirect } from '@tanstack/react-router'

// The Facilities list is the Houses page now. `replace` keeps Back from
// returning to a page that only bounces.
export const Route = createFileRoute(
  '/_authenticated/_organization/facilities/'
)({
  beforeLoad: () => {
    throw redirect({ to: '/houses', replace: true })
  },
})
